// management-frontend/src/components/CustomerSystem.js

import React, { useEffect, useState, useMemo } from "react";
import apiServices from "../services/apiServices";
import apiServicesOpervex from "../services/apiServicesOpervex";
import Navbar from "./Navbar";
import { TbPlugConnected } from "react-icons/tb";
import { MdOutlineSync, MdArrowDownward, MdArrowUpward } from "react-icons/md";
import { PiTrashLight } from "react-icons/pi";
import FileSelectorService from "../services/FileSelectorService";
import ConfirmService from "../components/ConfirmationModal/ConfirmService";
import TestConnection from "../context/TestConnection";

const defaultDatabase = {
  idCustomer: "",
  type: "",
  name: "",

  startDate: null,
  endDate: null,

  imgFile: "",
  imgLength: null,
  imgType: "",

  server: "",
  port: 3306,
  database: "",
  username: "",
  password: "",

  apiKey: "",
  apiValue: "",

  secretAccess: "",
  secretRefresh: "",

  powerbiUser: "",

  disabled: false,
};

const sysTypes = [
  {
    id: "OPERVEX",
    name: "Opervex",
  },
  {
    id: "OPERVEXALU",
    name: "Aluguel",
  },
];

const CustomerSystem = () => {
  const [action, setAction] = useState("");
  const [systems, setSystems] = useState([]);
  const [customers, serCustomers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentSystem, setCurrentSystem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const api = new apiServices();
  const apiOpervex = new apiServicesOpervex();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    try {
      const systs = await api.getAllCustomersSystem();
      const custs = await api.getAllCustomers();

      setSystems(systs);
      serCustomers(custs);
    } catch (err) {
      console.error("Erro ao buscar clientes:", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setCurrentSystem((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleActionDatabase = async (command) => {
    try {
      const log = { message: "", success: false };
      let file = null;

      setLoading(true);
      setTestResult(null);

      const actions = {
        Synchronize: apiOpervex.Synchronize,
        Backup: apiOpervex.Backup,
        Restore: apiOpervex.Restore,
        Delete: apiOpervex.Delete,
      };

      const cust = customers.find((x) => x.id === currentSystem.idCustomer);
      const action = actions[command];

      switch (command) {
        case "Restore":
          file = await FileSelectorService.selectFile({ accept: ".zip" });

          if (!file) {
            setLoading(false);
            return;
          }
          break;
        case "Delete":
          const result = await ConfirmService.show("Eliminação", "Deseja realmete eliminar os dados?");

          if (!result) {
            setLoading(false);
            return;
          }
          break;
        default:
          break;
      }

      const response = await action(cust.guid, currentSystem.apiValue, file);

      if (command === "Backup") {
        const filename = `backup_${cust.guid}_${new Date().toISOString().replace(/[:.]/g, "-")}.zip`;

        downloadFile(response.data, filename, "application/zip");

        log.message = `<b>Arquivo Gerado:</b> ${filename}`;
        log.success = true;
      } else {
        if (response && Array.isArray(response)) {
          response.forEach((item) => {
            if (log.message !== "") log.message += "</br>";

            switch (item.type) {
              case "warning":
                log.message += "⚠️ " + item.message;
                break;
              case "success":
                log.message += "✅ " + item.message;
                break;
              case "error":
                log.message += "❌ " + item.message;
                break;
              default:
                log.message += item.message;
                break;
            }
          });

          log.success = true;
        } else {
          log.message = "❌ Error: " + response.error ?? response;
        }
      }

      setTestResult(log);
    } finally {
      setLoading(false);
    }
  };

  const downloadFile = (data, fileName, type) => {
    const blob = new Blob([data], { type });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(url);
  };

  const handleTestConnection = async (e) => {
    try {
      setLoading(true);
      setTestResult(null);

      // Envia os dados do sistema para a API
      const responde = await new TestConnection().Test(
        currentSystem.server,
        currentSystem.port,
        currentSystem.username,
        currentSystem.password,
        currentSystem.database,
      );

      if (responde.success) {
        setTestResult({ success: true, message: "✅ Conexão bem-sucedida!" });
      } else {
        setTestResult({ success: false, message: "❌ Falha na conexão." });
      }
    } catch (error) {
      setTestResult({
        success: false,
        message: "⚠️ Erro ao testar conexão: " + (error.response?.data?.message || error.message),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (database, action) => {
    setAction(action);
    setLoading(false);
    setTestResult(null);

    if (action === "create")
      setCurrentSystem({
        ...database,
        apiKey: generateSecret(50),
        apiValue: generateSecret(50),
        secretAccess: generateSecret(50),
        secretRefresh: generateSecret(50),
      });
    else setCurrentSystem(database);

    setShowModal(true);
  };

  const handleDelete = (database) => {
    setCurrentSystem(database);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await api.deleteCustomerSystem(currentSystem.id);
      setShowDeleteModal(false);
      fetchData();
    } catch (err) {
      console.error("Erro ao excluir bando de dados do cliente:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = { ...currentSystem };
    const result = await api.createCustomerSystem(data);

    if (result.errors) {
      var messages = "";

      result.errors.forEach((error) => {
        messages += error.message + "\n";
      });

      alert(messages);

      return;
    }

    if (result?.id) {
      await handleSyncroDataBase(result.id);
    }

    setShowModal(false);
    setCurrentSystem(defaultDatabase);
    fetchData();
  };

  const handleSyncroDataBase = async (id) => {
    const syst = await api.getCustomersSystem(id);

    try {
      // Envia os dados do sistema para a API
      const responde = await new TestConnection().Test(syst.server, syst.port, syst.username, syst.password, syst.database);
      if (responde.success) {
        //          setTestResult({ success: true, message: "✅ Conexão bem-sucedida!" });
      } else {
        //          setTestResult({ success: false, message: "❌ Falha na conexão." });
      }
    } catch (error) {}
  };

  const handleUpdate = async (e) => {
    const data = { ...currentSystem };

    e.preventDefault();

    const result = await api.updateCustomerSystem(currentSystem.id, data);

    if (result.errors) {
      var messages = "";

      result.errors.forEach((error) => {
        messages += error.message + "\n";
      });

      alert(messages);

      return;
    }

    setShowModal(false);
    fetchData();
  };

  const generateSecret = (length) => {
    let result = "";
    const characters = "abcdefghijklmnopqrstuvwxyz0123456789";

    // Loop to generate characters for the specified length
    for (let i = 0; i < length; i++) {
      const randomInd = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomInd);
    }
    return result;
  };

  const formatDate = (date) => {
    try {
      if (!date) return "";
      else return new Date(date + "T00:00").toLocaleDateString("pt-BR");
    } catch {
      return "";
    }
  };

  const getStatus = (syst) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const start = new Date(syst.startDate + "T00:00");
    start.setHours(0, 0, 0, 0);

    const end = new Date(syst.endDate + "T00:00");
    end.setHours(0, 0, 0, 0);

    const timeDiff = end.getTime() - today.getTime();
    const daysDiff = timeDiff / (1000 * 3600 * 24);

    if (syst.disabled) return { text: "Inativo", class: "bg-danger text-white" };
    else if (!syst.startDate) return { text: "Data Início não definida", class: "bg-danger text-white" };
    else if (!syst.endDate) return { text: "Data Fim não definida", class: "bg-danger text-white" };
    else if (end < today) return { text: "Vencido", class: "bg-danger text-white" };
    else if (start > today) return { text: "Aguardando período de início", class: "bg-warning text-dark" };
    else if (daysDiff <= 30) return { text: "A Vencer", class: "bg-warning text-dark" };
    else return { text: "Ativo", class: "bg-success text-white" };
  };

  const handleRemoveImage = (e) => {
    setCurrentSystem((prev) => ({
      ...prev,
      imgFile: "",
      imgLength: null,
      imgType: "",
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result.replace(/^data:image\/[a-zA-Z0-9+-]+;base64,/, "");

        setCurrentSystem((prev) => ({
          ...prev,
          imgFile: base64String,
          imgType: file.type,
          imgLength: file.size,
        }));
      };

      reader.readAsDataURL(file);
    }
  };

  const customerName = useMemo(() => {
    return customers.find((x) => x.id === currentSystem?.idCustomer)?.name || "";
  }, [customers, currentSystem?.idCustomer]);

  return (
    <div>
      <Navbar />
      <div className="container-fluid mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Bancos de Dados</h2>
          <button className="btn btn-success" onClick={() => handleEdit(defaultDatabase, "create")}>
            Adicionar Banco de Dados
          </button>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th className="text-center">Status</th>
              <th className="text-center">Guid</th>
              <th>Cliente</th>
              <th className="text-center">Tipo do Sistema</th>
              <th>Nome do Sistema</th>
              <th className="text-center">Data Início</th>
              <th className="text-center">Data Fim</th>
              <th className="text-center">Inativo</th>
              <th className="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            {systems.map((syst) => {
              const cust = customers.find((x) => x.id === syst.idCustomer);
              const sysType = sysTypes.find((x) => x.id === syst.type);
              const status = getStatus(syst);

              return (
                <tr key={syst.id}>
                  <td className="text-center">
                    <span className={`badge rounded-pill ${status.class}`}>{status.text}</span>
                  </td>
                  <td className="text-center">{cust.guid}</td>
                  <td>
                    {cust?.id} - {cust?.name}
                  </td>
                  <td className="text-center">{sysType.name}</td>
                  <td>{syst.name}</td>
                  <td className="text-center">{formatDate(syst.startDate)}</td>
                  <td className="text-center">{formatDate(syst.endDate)}</td>
                  <td className="text-center">{syst.disabled ? "Sim" : "Não"}</td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(syst, "change")}>
                      Editar
                    </button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(syst)}>
                      Excluir
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Modal para adicionar novo cliente */}
        {showModal && (
          <div className="modal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{action === "create" ? "Adicionar Bando de dados" : "Editar dando de dados"}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)} disabled={loading}></button>
                </div>
                <div className="modal-body">
                  <form>
                    {/* Abas */}
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="geral-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#geral"
                          type="button"
                          role="tab"
                          aria-controls="geral"
                          aria-selected="true"
                        >
                          Dados Gerais
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="system-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#system"
                          type="button"
                          role="tab"
                          aria-controls="system"
                          aria-selected="true"
                        >
                          Dados de Integração
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="secret-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#secret"
                          type="button"
                          role="tab"
                          aria-controls="secret"
                          aria-selected="false"
                        >
                          Dados de Segurança
                        </button>
                      </li>

                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="imagem-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#imagem"
                          type="button"
                          role="tab"
                          aria-controls="imagem"
                          aria-selected="false"
                        >
                          Imagem
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="additional-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#additional"
                          type="button"
                          role="tab"
                          aria-controls="additional"
                          aria-selected="false"
                        >
                          Dados Adicionais
                        </button>
                      </li>
                    </ul>

                    {/* Conteúdo das Abas */}
                    <div className="tab-content mt-3" id="myTabContent">
                      {/* Dados Gerais*/}
                      <div className="tab-pane fade show active" id="geral" role="tabpanel" aria-labelledby="geral-tab">
                        <div className="mb-3">
                          <label className="form-label">Cliente</label>
                          {action === "create" ? (
                            <select class="form-select" name="idCustomer" onChange={handleInputChange}>
                              <option value="">Selecione...</option>
                              {customers?.map((customer) => (
                                <option key={customer.id} value={customer.id}>
                                  {customer.name}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input type="text" className="form-control" name="name" value={customerName} disabled />
                          )}
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Tipo do Sistema</label>
                          {action === "create" ? (
                            <select class="form-select" name="type" value={currentSystem.type} onChange={handleInputChange}>
                              <option value="">Selecione...</option>

                              {sysTypes.map((sysType) => (
                                <option key={sysType.id} value={sysType.id}>
                                  {sysType.name}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input type="text" className="form-control" name="name" value={currentSystem.type} disabled />
                          )}
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Nome do Sistema</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={currentSystem.name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Data Início</label>
                          <input
                            type="date"
                            className="form-control"
                            name="startDate"
                            value={currentSystem.startDate}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Data Fim</label>
                          <input
                            type="date"
                            className="form-control"
                            name="endDate"
                            value={currentSystem.endDate}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="mb-3 form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="disabled"
                            checked={currentSystem.disabled}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label">Inativo</label>
                        </div>
                      </div>
                      {/* Dados de Integração */}
                      <div className="tab-pane fade show" id="system" role="tabpanel" aria-labelledby="system-tab">
                        <div hidden={currentSystem.type === "OPERVEX"}>
                          <div className="mb-3">
                            <label className="form-label">Servidor</label>
                            <input
                              type="text"
                              className="form-control"
                              name="server"
                              value={currentSystem.server}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Porta</label>
                            <input
                              type="text"
                              className="form-control"
                              name="port"
                              value={currentSystem.port}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Bando de Dados</label>
                            <input
                              type="text"
                              className="form-control"
                              name="database"
                              value={currentSystem.database}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Usuário</label>
                            <input
                              type="text"
                              className="form-control"
                              name="username"
                              value={currentSystem.username}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Senha</label>
                            <input
                              type="text"
                              className="form-control"
                              name="password"
                              value={currentSystem.password}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <br />
                        <button
                          type="button"
                          className="btn btn-info me-2"
                          disabled={loading}
                          onClick={handleTestConnection}
                          hidden={currentSystem.type === "OPERVEX"}
                        >
                          <TbPlugConnected />
                          Testar Conexão
                        </button>

                        <button
                          type="button"
                          className="btn btn-info m-2"
                          disabled={loading}
                          onClick={() => handleActionDatabase("Synchronize")}
                        >
                          <MdOutlineSync /> Sincronizar
                        </button>

                        <button
                          type="button"
                          className="btn btn-success me-2"
                          disabled={loading}
                          onClick={() => handleActionDatabase("Backup")}
                        >
                          <MdArrowDownward /> Backup
                        </button>

                        <button
                          type="button"
                          className="btn btn-warning me-2"
                          disabled={loading}
                          onClick={() => handleActionDatabase("Restore")}
                        >
                          <MdArrowUpward /> Restore
                        </button>

                        <button
                          type="button"
                          className="btn btn-danger me-2"
                          disabled={loading}
                          onClick={() => handleActionDatabase("Delete")}
                        >
                          <PiTrashLight /> Delete
                        </button>

                        {testResult && (
                          <div
                            className={`mt-3 alert ${testResult.success ? "alert-success" : "alert-danger"}`}
                            dangerouslySetInnerHTML={{ __html: testResult.message }}
                          ></div>
                        )}
                      </div>
                      {/* Secret */}
                      <div className="tab-pane fade show" id="secret" role="tabpanel" aria-labelledby="secret-tab">
                        <div className="mb-3">
                          <label className="form-label">Api Key</label>
                          <input type="text" className="form-control" name="apiKey" value={currentSystem.apiKey} disabled />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Api Value</label>
                          <input type="text" className="form-control" name="apiValue" value={currentSystem.apiValue} disabled />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Secret Access</label>
                          <input
                            type="text"
                            className="form-control"
                            name="secretAccess"
                            value={currentSystem.secretAccess}
                            onChange={handleInputChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Secret Refresh</label>
                          <input
                            type="text"
                            className="form-control"
                            name="secretRefresh"
                            value={currentSystem.secretRefresh}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      {/* Image */}
                      <div className="tab-pane fade" id="imagem" role="tabpanel" aria-labelledby="imagem-tab">
                        <div className="mb-3">
                          <button
                            type="button"
                            className="btn btn-sm btn-primary  me-2"
                            onClick={() => document.getElementById("fileInput").click()}
                          >
                            Carregar Imagem
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger  me-2"
                            onClick={handleRemoveImage}
                            disabled={!currentSystem.imgFile}
                          >
                            Remover imagem
                          </button>
                          <input
                            type="file"
                            id="fileInput"
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={(e) => handleImageUpload(e)}
                          />
                        </div>
                        {currentSystem.imgFile && (
                          <img
                            src={`data:${currentSystem.imgFile};base64,${currentSystem.imgFile}`}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "fill",
                            }}
                            className="img-fluid"
                            alt="Imagem do Cliente"
                          />
                        )}
                      </div>
                      {/* Secret */}
                      <div className="tab-pane fade show" id="additional" role="tabpanel" aria-labelledby="additional-tab">
                        <div className="mb-3">
                          <label className="form-label">Usuário Power BI</label>
                          <input
                            type="email"
                            className="form-control"
                            name="powerbiUser"
                            value={currentSystem.powerbiUser}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {/* Botões */}
                    <div className="d-flex justify-content-end mt-3">
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        onClick={() => setShowModal(false)}
                        disabled={loading}
                      >
                        Cancelar
                      </button>
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={action === "create" ? handleSubmit : handleUpdate}
                        disabled={loading}
                      >
                        Salvar
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal para confirmar exclusão */}
        {showDeleteModal && currentSystem && (
          <div className="modal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirmar Exclusão</h5>
                  <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
                </div>
                <div className="modal-body">
                  <p>
                    Tem certeza que deseja excluir o bando de dados <strong>{currentSystem.type}</strong> do cliente{" "}
                    <strong>{customerName}</strong>?
                  </p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                    Cancelar
                  </button>
                  <button type="button" className="btn btn-danger" onClick={confirmDelete}>
                    Confirmar Exclusão
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerSystem;
